/**
 * TutorLiveMedia (web) — ce que la salle du tuteur monte à sa racine, hors de la page : le son des
 * élèves. L'ancienne barre montait `<RoomAudioRenderer volume={1}>` (`ControlBarM.web.tsx`, le tuteur
 * toujours en son : `isSoundMode || isTutor` de `LiveModeFooter.js`) ; sans lui, le tuteur n'entend
 * aucun élève. Le même composant que l'élève (`shared/live/LiveAudio`), toujours en Dialogue, avec sa
 * boîte « Touche pour réactiver le son » quand le navigateur bloque la lecture.
 *
 * Le partage d'écran du web n'a rien à monter : `getDisplayMedia` ouvre le sélecteur du navigateur.
 */
import React from "react"

import { type EngineTelemetry } from "../../../../../../engine/shared/telemetry"
import { LiveAudio } from "../../shared/live/LiveAudio.web"

export type TutorLiveMediaProps = {
    telemetry: EngineTelemetry
    /** Une boîte de la salle est à l'écran : celle du son attend derrière. Défaut `false`. */
    covered?: boolean
}

export function TutorLiveMedia({ telemetry, covered = false }: TutorLiveMediaProps) {
    return <LiveAudio dialogue covered={covered} telemetry={telemetry} />
}
